import { Grid } from '@material-ui/core';
import { entityWarningContent } from './EntityWarningContent.tsx';
import {
  EntityAboutCard,
  EntityLinksCard,
  isComponentType,
} from '@backstage/plugin-catalog';
import {
  Direction,
  EntityCatalogGraphCard,
} from '@backstage/plugin-catalog-graph';
import {
  isSystemEntity,
  parseEntityRef,
  RELATION_API_CONSUMED_BY,
  RELATION_API_PROVIDED_BY,
  RELATION_CONSUMES_API,
  RELATION_DEPENDENCY_OF,
  RELATION_DEPENDS_ON,
  RELATION_HAS_PART,
  RELATION_PART_OF,
  RELATION_PROVIDES_API,
  stringifyEntityRef,
} from '@backstage/catalog-model';
import {
  EntityGrafanaAlertsCard,
  EntityGrafanaDashboardsCard,
} from '@backstage-community/plugin-grafana';
import { useEntity } from '@backstage/plugin-catalog-react';

export const EntityOverviewContent = () => {
  const { entity } = useEntity();
  const entityRef = stringifyEntityRef(entity);

  return (
    <Grid container>
      {entityWarningContent}
      <Grid item md={4} xs={12}>
        <EntityAboutCard />
      </Grid>
      <Grid item md={6} xs={12}>
        <EntityCatalogGraphCard
          direction={Direction.LEFT_RIGHT}
          height={320}
          relations={[
            RELATION_PART_OF,
            RELATION_HAS_PART,
            RELATION_API_CONSUMED_BY,
            RELATION_API_PROVIDED_BY,
            RELATION_CONSUMES_API,
            RELATION_PROVIDES_API,
            RELATION_DEPENDENCY_OF,
            RELATION_DEPENDS_ON,
          ]}
        />
      </Grid>
      <Grid item md={2} xs={12}>
        <EntityLinksCard />
      </Grid>
      <Grid item md={6} xs={12}>
        <EntityGrafanaDashboardsCard
          key={entityRef}
          additionalDashboards={e => {
            const isSystem = isSystemEntity(e);
            const systemComponentNames = isSystem
              ? (e.relations ?? [])
                  .filter(r => r.type === RELATION_HAS_PART)
                  .map(r => parseEntityRef(r.targetRef))
                  .filter(ref => ref.kind === 'component')
                  .map(ref => ref.name)
              : [];
            const isService = isComponentType('service')(e);
            const isFrontend = isComponentType('frontend')(e);
            return [
              ...(isSystem && systemComponentNames.length > 0
                ? [
                    {
                      title: 'Version Drift',
                      folderTitle: '',
                      folderUrl: '',
                      url: `https://grafana.irie.rocks/d/version-drift/version-drift?${systemComponentNames
                        .map(n => `var-component=${encodeURIComponent(n)}`)
                        .join('&')}&viewPanel=panel-1`,
                      tags: ['version-drift'],
                    },
                  ]
                : []),
              ...(isService || isFrontend
                ? [
                    {
                      title: 'Version Drift',
                      folderTitle: '',
                      folderUrl: '',
                      url: `https://grafana.irie.rocks/d/version-drift/version-drift?var-component=${e.metadata.name}&var-type=${isService ? 'service' : 'frontend'}&viewPanel=panel-1`,
                      tags: ['version-drift'],
                    },
                  ]
                : []),
              ...(isService
                ? [
                    {
                      title: 'Four Golden Signals',
                      folderTitle: '',
                      folderUrl: '',
                      url: `https://grafana.irie.rocks/d/four-golden-signals?var-src=mimir-prod&var-env=$__all&var-svc=${e.metadata.name}&var-container=${e.metadata.name}`,
                      tags: ['golden-signals'],
                    },
                  ]
                : []),
            ];
          }}
        />
      </Grid>
      <Grid item md={6} xs={12}>
        <EntityGrafanaAlertsCard key={entityRef} showState />
      </Grid>
    </Grid>
  );
};
